import { Injectable } from '@angular/core';
import {
  NAMESPACE_ONBOARDING,
  OnboardingConfigurationKeys,
  OnboardingConfigurations,
  OnboardingConfigurationValue,
  OnboardingItem,
  OnboardingTarget,
} from '@epicuro-next/constants/rule-engine/onboarding-rules';
import { selectConfigurationValueFrom } from '@epicuro-next/platform/configuration';
import { isNonNullish } from '@epicuro-next/utilities';
import { createEffect } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { filter, map } from 'rxjs/operators';

import * as OnboardingActions from './onboarding.actions';

@Injectable()
export class OnboardingEffects {
  public onboardingConfiguration$ = this.store.pipe(
    select(
      selectConfigurationValueFrom<
        OnboardingConfigurationKeys.Configuration,
        OnboardingConfigurations
      >(
        NAMESPACE_ONBOARDING,
        OnboardingConfigurationKeys.Configuration,
        undefined,
      ),
    ),
    filter(isNonNullish),
    map((value: string) => JSON.parse(value)),
    filter((value: OnboardingConfigurationValue) => value.enabled),
  );

  constructor(private store: Store) {}

  public initOnboardingEffects$ = createEffect(() =>
    this.onboardingConfiguration$.pipe(
      map((value) => {
        const consumerOnboarding: OnboardingItem[] =
          this.createTargetConfiguration(
            value.consumer,
            OnboardingTarget.Consumer,
          );

        const salesOnboarding: OnboardingItem[] =
          this.createTargetConfiguration(
            value.sales,
            OnboardingTarget.SalesRep,
          );

        return OnboardingActions.setOnboardingConfiguration({
          consumer: consumerOnboarding,
          sales: salesOnboarding,
        });
      }),
    ),
  );

  private createTargetConfiguration(
    value: OnboardingItem[],
    target: OnboardingTarget,
  ) {
    return (
      value?.map((item: OnboardingItem, index: number) => ({
        ...item,
        descriptionTranslationKey: this.getKeyValue(
          index,
          target,
          'description',
        ),
        titleTranslationKey: this.getKeyValue(index, target, 'title'),
        nextButtonTranslationKey: this.getKeyValue(
          index,
          target,
          'button-next',
        ),
      })) ?? null
    );
  }

  private getKeyValue(index: number, role: string, section: string) {
    return `step-${index + 1}-${role}-${section}`;
  }
}
